import React, { useState, useEffect, useCallback } from "react";
import "./delete-user.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import MemberLineItem from "./member-line-item";

import {
  clearNotifications,
  selectUsersNotifications,
  selectMember,
  setMember,
  getOrganizationUser, deleteOrganizationUser,
} from "../../reducers/userSlice";

import { setNotifications } from "../../reducers/appSlice";
import { getRemoveTitle, removeItemForm } from "../../forms/DeleteForm";

const DeleteUser = () => {
  const [isValid, setIsValid] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/permissions/:memberID/*");

  const orgNotifications = useSelector(selectUsersNotifications);
  const currentMember = useSelector(selectMember);

  const backToList = () => {
    navigate(`/${matchEdit.params.id}/permissions`);
  };

  const loadMember = useCallback(() => {
    if (matchEdit?.params?.memberID !== "add") {
      if (matchEdit?.params?.["*"] === "delete-member") {
        dispatch(getOrganizationUser(matchEdit?.params?.memberID));
      }
    }
  }, [dispatch, matchEdit?.params]);

  useEffect(() => {
    loadMember();
    return () => {
      dispatch(setMember({}));
    };
  }, [loadMember, dispatch]);


  useEffect(() => {
    if (
      orgNotifications.length > 0 &&
      orgNotifications[0].state === "success"
    ) {
      dispatch(setNotifications(orgNotifications));
      navigate(`/${matchEdit.params.id}/permissions`);
    }
  }, [orgNotifications, dispatch, navigate, matchEdit.params.id]);

  const removeMember = () => {
    setIsValid(false);
    if (matchEdit.params.id) {
      if (matchEdit?.params?.["*"] === "delete-member") {
        dispatch(deleteOrganizationUser(matchEdit?.params?.memberID));
      }
    }
  };

  const leftNavigation = () => {
    navigate(-1);
  };
  const getActions = () => {
    let actions = [
      {
        name: "Delete",
        action: removeMember,
        isDisabled: !isValid,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Delete User",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = orgNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };
  const timeoutAction = () => {
    dispatch(clearNotifications());
  };
  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to user list",
        size: "secondary",
        actionClick: backToList,
      },
    ];
  };

  const getContent = () => {
    const identifier = currentMember?.user?.name ? currentMember?.user?.name : currentMember?.user?.email;
    return (
      <GSForm
        formTitle={getRemoveTitle("Delete User")}
        formSections={removeItemForm(
          identifier,
          <MemberLineItem {...currentMember} hideInvitation></MemberLineItem>,
          "remove",
          `Are you sure you want to remove ${identifier} from your organization? This cannot be undone.`
        )}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <delete-user>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </delete-user>
  );
};

export default DeleteUser;
